module.exports = __webpack_public_path__ + "static/screen7-348578b77323e3993bbd7528cab76f30.webp";